<template>
  <div class="px-4 py-8 w-full min-h-screen" v-loading="loading"
       element-loading-text="Loading..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <Customers />
  </div>
</template>

<script>
import Customers from '../components/Customers.vue';
import CustomerCharts from '../components/CustomerCharts.vue';

export default {
  name: 'Customer360',
  components: {
    Customers,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async fetchAllData() {
      try {
        this.loading = true;
        await this.$store.dispatch('AICustomers/getCustomers', { page: 1, limit: 10 });

        this.loading = false;
      } catch (e) {
        console.log(e)
        this.loading = false;
      }

      this.loading = false;
    },
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    this.fetchAllData();
  },
};
</script>
